<template>
  <core-header-dropdown no-caret right>
    <template #header>
      <font-awesome-icon :icon="['fal', 'thumbs-up']" />
      <b-badge v-if="itemsCount" pill variant="warning">{{ itemsCount }}</b-badge>
    </template>

    <template #dropdown>
      <b-dropdown-header class="dropdown-menu-lg text-center" tag="div">
        <b>{{ itemsCount === 0 ? "No" : itemsCount }} Accepted Quotes</b>
      </b-dropdown-header>

      <b-dropdown-item v-if="currentPage === 'jobs.edit'">
        <button class="btn btn-primary btn-sm" @click.prevent.stop="turnOnFilter">
          Show Accepted Quote Jobs
        </button>
      </b-dropdown-item>

      <b-dropdown-item
        v-for="quote in quotes"
        :key="quote.id"
        class="w-100"
        @click.prevent="open(quote.id)"
      >
        #{{ quote.job_id }}J
      </b-dropdown-item>

      <b-dropdown-item @click.prevent="openList">
        <b>View All Accepted Quotes</b>
      </b-dropdown-item>
    </template>
  </core-header-dropdown>
</template>

<script>
import { HeaderDropdown as CoreHeaderDropdown } from "@coreui/vue";
import EventBus from "../../imports/event-bus";

export default {
  components: {
    CoreHeaderDropdown,
  },

  data() {
    return {
      quotes: [],
      itemsCount: 0,
    };
  },

  computed: {
    currentPage() {
      return this.$route.name;
    },
  },

  mounted() {
    this.init();

    EventBus.$on("quote-processed", () => {
      this.init();
    });
  },

  methods: {
    init() {
      this.$http
        .get("/invoices?limit=5&accepted=1&&orderBy=accepted_at&sortedBy=desc")
        .then((response) => {
          this.quotes = response.body.data;
          this.itemsCount = response.body.total;
        });
    },

    open(id) {
      window.open(`/invoices/${id}/edit`);
    },

    openList() {
      window.open("/invoices/accepted-quote-list");
    },

    turnOnFilter() {
      EventBus.$emit("list-withAcceptedQuotes");
    },
  },
};
</script>
